export default __webpack_public_path__ + "static/media/more-about-jumps.50286268.yaml";